import React, { useEffect, useState, useRef } from 'react';
import { Box, TextField, Button, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Autocomplete } from "@mui/material";
import { Edit, Delete, Save, Close } from "@mui/icons-material";
import { purchase_order_concepts_get } from '../../../services/expenses/purchase_orders';
import { purchase_order_concept_put, purchase_order_concept_post, purchase_order_concept_delete } from '../../../services/expenses/purchase_orders';
import { showAlert } from '../../../main_components/alerts/alert_response.jsx';
import MODAL_TABLE from '../../../main_components/modal/modal_Table';
import NOTIFICATION_SYSTEM from '../../../main_components/alerts/notification_sistem';
interface ProductDetail {
  id: string;
  code: string;
  product?: string;
  description: string;
  price: number;
  quantity: number;
  total: number;
  clave_prod_serv?: string;
  clave_unidad?: string;
  unidad?: string;
  id_purchase_order_fk?: string | number;
}

interface Concept {
  description: string;
  unitary_price: number;
  identification_number: string;
  clave_unidad?: string;
  clave_prod_serv?: string;
  unidad?: string;
}
interface CustomTableProps {
  data: any;
  onDataChange: (newData: { fetch_roles: any[]; custom_roles: any }, user_roles?: any) => void;
}

const CustomTable: React.FC<CustomTableProps> = ({ data, onDataChange }) => {

  const [customTableProps, setcustomTableProps] = useState(data);
  const notificationSystemRef = useRef<any>(null);
  const [modalT, setmodalT] = useState(false);
  const [concepts, setConcepts] = useState<Concept[]>([]);
  const [details, setDetails] = useState<ProductDetail[]>(data?.details);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedConcept, setSelectedConcept] = useState<Concept | null>(null);
  const [totalDetails, setTotalDetails] = useState<number>(0); // Estado para el total general
  const [currentDetail, setCurrentDetail] = useState<ProductDetail>({
    id: "",
    description: "",
    price: 0.0001,
    quantity: 1,
    code: "",
    clave_prod_serv: "",
    clave_unidad: "",
    unidad: "",
    total: 0,
  });

  const [errors, setErrors] = useState<Partial<Record<keyof ProductDetail, string>>>({});

  useEffect(() => {
    onDataChange({ ...data, customTableProps });
  }, [customTableProps]);

  console.log(currentDetail)
  useEffect(() => {
    fetchConcepts();
  }, []);

  useEffect(() => {
    const newTotal = details.reduce((sum, detail) => sum + detail.total, 0);
    setTotalDetails(newTotal);


    console.log(details)
    setcustomTableProps({ details: details, total: newTotal?.toFixed(4) });
  }, [details]);

  const fetchConcepts = async () => {
    try {
      const response = await purchase_order_concepts_get();
      setConcepts(response.data);
    } catch (error) {
      console.error("Error al obtener los conceptos:", error);
    }
  };

  const handleAutocompleteChange = (event: any, newValue: Concept | null) => {
    setSelectedConcept(newValue);
    console.log(newValue)
    if (newValue) {
      setCurrentDetail({
        id: isEditing ? currentDetail.id : Math.random().toString(36).substring(2, 9),
        description: newValue.description,
        product: newValue.description,
        price: newValue.unitary_price,
        quantity: 1,
        clave_unidad: newValue.clave_unidad || "",
        code: newValue.identification_number,
        clave_prod_serv: newValue.clave_prod_serv || "",
        total: newValue.unitary_price * 1,
        unidad: newValue.unidad || ""
      });
    }
  };

  const handleInputChange = (field: keyof ProductDetail, value: string | number) => {
    // Convertir a número si el campo es 'price' o 'quantity'
    // const parsedValue =
    //   field === "price" || field === "quantity"
    //     ? (value)
    //     : value;

    const updatedDetail = {
      ...currentDetail,
      [field]: value
    };

    // Recalcular el total si se modifican 'price' o 'quantity'
    if (field === "price" || field === "quantity") {
      updatedDetail.total = Number(updatedDetail.price) * Number(updatedDetail.quantity);
    }

    setCurrentDetail(updatedDetail);
  };


  const handleSave = async () => {
    const newErrors: Partial<Record<keyof ProductDetail, string>> = {};

    // if (!currentDetail.code?.trim()) newErrors.code = "Campo requerido";
    if (!currentDetail.description?.trim()) newErrors.description = "Campo requerido";
    if (!currentDetail.unidad?.trim()) newErrors.unidad = "Campo requerido";
    if (!currentDetail.clave_unidad?.trim()) newErrors.clave_unidad = "Campo requerido";
    if (!currentDetail.clave_prod_serv?.trim()) newErrors.clave_prod_serv = "Campo requerido";

    console.log(currentDetail.quantity)
    if (!currentDetail.quantity || Number(currentDetail.quantity) < 0.0001)
      newErrors.quantity = "Debe ser mayor o igual a 0.0001";

    else if (!/^(\d+)?(\.\d{1,4})?$/.test(currentDetail.quantity.toString()))
      newErrors.quantity = "Máximo 4 decimales";

    if (!currentDetail.price || Number(currentDetail.price) < 0.0001)
      newErrors.price = "Debe ser mayor o igual a 0.0001";
    else if (!/^(\d+)?(\.\d{1,4})?$/.test(currentDetail.price.toString()))
      newErrors.price = "Máximo 4 decimales";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});

    const newDetail = {
      ...currentDetail,
      price: Number(currentDetail.price),
      product: currentDetail.description ?? "",
      code: currentDetail.code ?? "",
      quantity: Number(currentDetail.quantity),
      total: Number((Number(currentDetail.price) * Number(currentDetail.quantity)).toFixed(4)),
    };

    try {
      if (data?.update) {
        if (isEditing) {
          setmodalT(true);
          await purchase_order_concept_put(data.id_order, currentDetail.id, newDetail);
          showAlert({ msj: 'Concepto actualizado correctamente', status: true, notificationSystemRef });
          setmodalT(false);
          setDetails(details.map((detail) => (detail.id === currentDetail.id ? newDetail : detail)));
        } else {
          setmodalT(true);
          const response = await purchase_order_concept_post(data.id_order, newDetail);
          newDetail.id = response.data.id_detail;
          showAlert({ msj: 'Concepto agregado correctamente', status: true, notificationSystemRef });
          setmodalT(false);
          setDetails([...details, newDetail]);
        }
      } else {
        if (isEditing) {
          setDetails(details.map((detail) => (detail.id === currentDetail.id ? newDetail : detail)));
        } else {
          setDetails([...details, { ...newDetail, id: Math.random().toString(36).substring(2, 9) }]);
        }
      }

      resetForm();
    } catch (error: any) {
      showAlert({
        msj: error.response?.data?.errorMessage?.es || "Ocurrió un error",
        status: false,
        notificationSystemRef,
      });
      setmodalT(false);
      console.error(error);
    }
  };


  const handleEdit = (detail: ProductDetail) => {
    setCurrentDetail(detail);
    setIsEditing(true);
    setSelectedConcept(null);
  };

  const handleDelete = async (id: string) => {
    if (data?.update) {
      try {
        setmodalT(true)
        await purchase_order_concept_delete(data.id_order, id);
        showAlert({
          msj: 'Concepto eliminado correctamente',
          status: true,
          notificationSystemRef: notificationSystemRef,
        });
        setmodalT(false)
        setDetails(details.filter((detail) => detail.id !== id));
      } catch (error: any) {
        showAlert({
          msj: error.response.data.errorMessage.es,
          status: false,
          notificationSystemRef: notificationSystemRef,
        });
        setmodalT(false)

        console.error(error);
      }
    } else {
      // Sin petición, solo actualiza local
      setDetails(details.filter((detail) => detail.id !== id));
    }
  };


  const handleCancelEdit = () => {
    resetForm();

  };

  const resetForm = () => {
    setCurrentDetail({
      id: "",
      description: "",
      price: 0,
      quantity: 1,
      clave_unidad: "",
      code: "",
      total: 0,
      product: "",
      clave_prod_serv: "",
      unidad: ""
    });
    setErrors({});

    setIsEditing(false);
    setSelectedConcept(null);
  };

  return (
    <Box>
      <MODAL_TABLE open={false} message={''} message2={''} modalGeneral={false} modalT={modalT} />
      <NOTIFICATION_SYSTEM notificationSystemRef={notificationSystemRef}></NOTIFICATION_SYSTEM>
      <Autocomplete
        options={concepts}
        getOptionLabel={(option) => option.description}
        value={selectedConcept}
        onChange={handleAutocompleteChange}
        isOptionEqualToValue={(option, value) => option.identification_number === value?.identification_number}
        renderInput={(params) => <TextField {...params} label="Selecciona un Producto" />}
      />

      <br />

      <Box sx={{ display: 'flex', gap: '5px', p: '2px' }}>




        <TextField
          sx={{ width: '100%' }}
          label="Código de Identificación"
          value={currentDetail.code}
          onChange={(e) => handleInputChange("code", e.target.value)}
          error={!!errors.code}
          helperText={errors.code}
        />

        <TextField
          sx={{ width: '100%' }}
          label="Cantidad"
          inputProps={{ step: "1", min: 1, pattern: "/^(\d+)?(\.\d{1,4})?$/" }}
          type="number"
          value={currentDetail.quantity}
          onChange={(e) => handleInputChange("quantity", (e.target.value))}
          error={!!errors.quantity}
          helperText={errors.quantity}
        />

        <TextField
          sx={{ width: '100%' }}
          label="Precio Unitario"
          type="number"
          inputProps={{ step: "0", min: 0, pattern: "\\d+(\\.\\d{0,4})?" }}
          value={currentDetail.price}
          onChange={(e) => {
            const value = (e.target.value);
            handleInputChange("price", value);
          }}
          error={!!errors.price}
          helperText={errors.price}
        />

        <TextField
          sx={{ width: '100%' }}
          label="Clave Unidad"
          value={currentDetail.clave_unidad}
          onChange={(e) => handleInputChange("clave_unidad", e.target.value)}
          error={!!errors.clave_unidad}
          helperText={errors.clave_unidad}
        />

        <TextField
          sx={{ width: '100%' }}
          label="Clave Producto/Servicio"
          value={currentDetail.clave_prod_serv}
          onChange={(e) => handleInputChange("clave_prod_serv", e.target.value)}
          error={!!errors.clave_prod_serv}
          helperText={errors.clave_prod_serv}
        />

        <TextField
          sx={{ width: '100%' }}
          label="Unidad"
          value={currentDetail.unidad}
          onChange={(e) => handleInputChange("unidad", e.target.value)}
          error={!!errors.unidad}
          helperText={errors.unidad}
        />

      </Box>

      <br />

      <Box sx={{ display: 'flex', gap: '5px', p: '2px' }}>

        <TextField
          sx={{ width: '100%' }}
          label="Descripción"
          multiline
          maxRows={10}
          value={currentDetail.description}
          onChange={(e) => handleInputChange("description", e.target.value)}
          error={!!errors.description}
          helperText={errors.description}
        />
      </Box>

      <Box sx={{ display: "flex", gap: "10px", marginTop: "10px" }}>
        {isEditing ? (
          <>
            <Button variant="outlined" startIcon={<Close />} onClick={handleCancelEdit}>
              Cancelar
            </Button>
            <Button variant="contained" color="primary" startIcon={<Save />} onClick={handleSave}>
              Guardar Cambios
            </Button>
          </>
        ) : (
          <Button variant="contained" color="primary" onClick={handleSave}>
            Agregar Detalle
          </Button>
        )}
      </Box>

      <TableContainer
        component={Paper}
        style={{
          marginTop: "16px",
          maxHeight: "300px", // Puedes ajustar este valor según tu diseño
          overflowY: "auto"
        }}
      >        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Acciones</TableCell>
              <TableCell>Codigo</TableCell>
              <TableCell>Descripción</TableCell>
              <TableCell>Cantidad</TableCell>
              <TableCell>Precio Unitario</TableCell>
              <TableCell>Total</TableCell>
              <TableCell>Clave Unidad</TableCell>
              <TableCell>Clave Producto/Servicio</TableCell>
              <TableCell>Unidad</TableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {details.map((detail) => (
              <TableRow key={detail.id} >
                <TableCell>
                  <Edit style={{ cursor: "pointer" }} onClick={() => handleEdit(detail)} />
                  <Delete style={{ cursor: "pointer" }} color="error" onClick={() => handleDelete(detail.id)} />
                </TableCell>
                <TableCell>{detail.code}</TableCell>
                <TableCell>{detail.description}</TableCell>
                <TableCell>{Number(detail.quantity).toFixed(4)}</TableCell>
                <TableCell>${Number(detail.price).toFixed(4)}</TableCell>
                <TableCell>${detail.total.toFixed(4)}</TableCell>
                <TableCell>{detail.clave_unidad}</TableCell>
                <TableCell>{detail.clave_prod_serv}</TableCell>
                <TableCell>{detail.unidad}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TableRow>
        <TableCell colSpan={5} align="right"><b>Total General:</b></TableCell>
        <TableCell><b>${totalDetails.toFixed(4)}</b></TableCell>
      </TableRow>
    </Box>
  );
};

export default CustomTable;
